import React from "react";
import { PieChart } from "@mantine/charts";
import "./StandardTestPieChart.css";

interface StandardTest {
  name: string;
  percentage: number;
}

interface StandardTestPieChartProps {
  data?: StandardTest[];
  size?: number;
}

// Function to interpolate between two RGB colors
const interpolateColor = (factor: number): string => {
  // #0066cc = RGB(0, 102, 204) - dark blue
  // #33b4ff = RGB(51, 180, 255) - light blue
  const startR = 0,
    startG = 102,
    startB = 204;
  const endR = 51,
    endG = 180,
    endB = 255;

  const r = Math.round(startR + (endR - startR) * factor);
  const g = Math.round(startG + (endG - startG) * factor);
  const b = Math.round(startB + (endB - startB) * factor);

  return `rgb(${r}, ${g}, ${b})`;
};

export const StandardTestPieChart: React.FC<StandardTestPieChartProps> = ({ data, size = 280 }) => {
  if (!data || data.length === 0) {
    return (
      <div className="standard-test-no-data">
        <div className="text-muted">No test data available</div>
      </div>
    );
  }

  const chartData = data.map((test, index) => {
    // Calculate interpolation factor (0 to 1)
    const factor = data.length === 1 ? 0 : index / (data.length - 1);

    return {
      name: test.name,
      value: test.percentage,
      color: interpolateColor(factor),
    };
  });

  return (
    <div className="standard-test-chart-wrapper">
      <div className="chart-container">
        <PieChart data={chartData} withLabels={false} size={size} strokeWidth={1} />
        <div className="chart-legend">
          {chartData.map((item, index) => (
            <div key={index} className="legend-item">
              <div className="legend-color" style={{ backgroundColor: item.color }}></div>
              <span className="legend-text">
                {item.name} ({item.value}%)
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
